import React from "react";
import ReviewOrder from "../ReviewOrder/ReviewOrder";

const ManageOrders = () => {
  return (
    <div style={{ height: "100vh" }}>
      <ReviewOrder></ReviewOrder>
    </div>
  );
};

export default ManageOrders;
